import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getContentPage } from "store/actions";

export default function Privacycenter() {
  const dispatch = useDispatch();

  const { content } = useSelector((state) => state?.contentpage);

  const getContent = () =>{
          return content?.length && content?.find((item)=> item?.slug === "privacy-and-policy")?.content;
  } 


  useEffect(() => {
    dispatch(getContentPage());
  }, []);

  return (
    <section className="Browsemuseums Privacycenter">
      <Container>
        <div className="Browsemuseums-para Privacycenter">
          <p>
            <div
              dangerouslySetInnerHTML={{
                __html: getContent() ||  `<div className="d-flex align-items-center justify-content-center">
                  <p>Loading....</p>
                </div>`,
              }}
            />
          </p>
        </div>
      </Container>
    </section>
  );
}
